/* eslint-disable no-inner-declarations */
import extend from 'extend';

export function merge(...args: Array<object | undefined>): any {
    return extend.apply(extend, args);
}

export namespace merge {
    export function recursive(...args: Array<object | undefined>): any {
        return extend.apply(extend, [true, ...args]);
    }
}
